/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ scope: NonNullable<unknown> }} Audit_Details_Trust_Window_Grant_DescInputs */



/**
* | output |
* | --- |
* | "A tool trust window was opened ({scope}), so matching tool calls run without asking for confirmation until it expires." |
*
* @param {Audit_Details_Trust_Window_Grant_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_trust_window_grant_desc = /** @type {((inputs: Audit_Details_Trust_Window_Grant_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Trust_Window_Grant_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ein Vertrauensfenster für Werkzeuge wurde geöffnet (${i?.scope}). Passende Werkzeugaufrufe laufen bis zum Ablauf ohne Rückfrage.`)
	return /** @type {LocalizedString} */ (`A tool trust window was opened (${i?.scope}), so matching tool calls run without asking for confirmation until it expires.`)
});